

import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer"; 




function Contact() {
    return (
        <section>
            <Header/>
            <main>
                <div className="section location-banner">
                      <img alt="" className="backgrouns-img" src="https://cdn.prod.website-files.com/63e0c726a8112a793bad80c9/63e213fc5fccf95af22ad1af_Background%20Banner.webp"/>
                    <div className="base-container w-container">
                        <h1>Contact Us</h1>
                    </div>
                </div>
                 <ContactForm/>
            </main>
            <Footer/>
        </section>
    )
}

export default Contact;